import TextArea from "../../../../../Components/Common/TextArea/TextArea";
import React from "react";
import Button from "../../../../../Components/Common/Button/Button";
import Input from "../../../../../Components/Common/Input/Input";
import ErrorMessage from "../../../../../Components/Common/ErrorMessage/ErrorMessage";
import LocationSearch, {
  LocationResult,
} from "../../../../../Components/Common/LocationSearch/LocationSearch";
import { CHAR_LIMIT } from "../../../../../utils/Common/Constant";
import { NewProjectFormValues } from "../types";
import { FormikErrors, FormikTouched } from "formik";

interface Step2ProjectInfoProps {
  values: NewProjectFormValues;
  errors: FormikErrors<NewProjectFormValues>;
  touched: FormikTouched<NewProjectFormValues>;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  setFieldValue: (name: string, value: unknown) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function Step2ProjectInfo({
  values,
  errors,
  touched,
  onChange,
  setFieldValue,
  onNext,
  onBack,
}: Step2ProjectInfoProps) {
  const handleLocationChange = (location: LocationResult | null) => {
    setFieldValue("projAddr", location ? location.displayName : "");
    setFieldValue(
      "projCoords",
      location && !location.isCustom
        ? { lat: location.lat, lon: location.lon }
        : null,
    );
  };
  const formatWithCommas = (val: string): string =>
    val ? Number(val).toLocaleString("en-US") : "";

  return (
    <div className="stepPanel active">
      <div className="card">
        <div className="cardTitle">Project Information</div>
        <div className="fieldGroup cols2To1">
          <div className="field">
            <label>
              Project Name <span className="req">*</span>
            </label>
            <Input
              type="text"
              id="projName"
              name="projName"
              value={values.projName}
              onChange={onChange}
              placeholder="e.g. Aroma Joes - Portland"
              isError={!!(touched.projName && errors.projName)}
            />
            <ErrorMessage
              value={values.projName}
              have={CHAR_LIMIT.NAME}
              touched={touched.projName}
              error={errors.projName}
            />
          </div>
          <div className="field">
            <label>
              Approx. Contract Value <span className="req">*</span>
            </label>
            <div className="inputWithPrefix">
              <span className="prefixSymbol">$</span>
              <Input
                type="text"
                id="projValue"
                name="projValue"
                value={formatWithCommas(values.projValue)}
                onChange={onChange}
                placeholder="0.00"
                isError={!!(touched.projValue && errors.projValue)}
              />
            </div>
            <ErrorMessage
              value={values.projValue}
              have={CHAR_LIMIT.SHORT}
              touched={touched.projValue}
              error={errors.projValue}
            />
          </div>
        </div>
        <div className="fieldGroup cols1">
          <div className="field">
            <label>
              Project Description <span className="req">*</span>
            </label>
            <TextArea
              id="projDesc"
              name="projDesc"
              value={values.projDesc}
              onChange={onChange}
              placeholder="Be specific..."
              className={
                !!(touched.projDesc && errors.projDesc) ? "error-input-red" : ""
              }
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
            <ErrorMessage
              value={values.projDesc}
              touched={touched.projDesc}
              error={errors.projDesc}
            />
          </div>
        </div>
        <div className="fieldGroup cols1">
          <div className="field">
            <label>
              Project Address <span className="req">*</span>
            </label>
            <LocationSearch
              id="projAddr"
              value={null}
              valueLabel={values.projAddr}
              onChange={handleLocationChange}
              placeholder="Search address, city, state…"
              allowCustom
              error={!!(touched.projAddr && errors.projAddr)}
            />
            <ErrorMessage touched={touched.projAddr} error={errors.projAddr} />
          </div>
        </div>
      </div>
      <div className="btnRow">
        <Button className="btn btnSecondary" onClick={onBack}>
          ← Back
        </Button>
        <Button className="btn btnPrimary" onClick={onNext}>
          Next: Contacts →
        </Button>
      </div>
    </div>
  );
}
